
$(function () {
	var $header = $('#web-header');
	var $navItems = $header.find('.list-items .MS__hover');
	 var $detailItems = $header.find('.item-detail');

	 // Ẩn hết ảnh khi load
		 $detailItems.addClass('Hide');


		 $navItems.each(function (idx) {
			 $(this).on('click', function (e) {
				 e.preventDefault();
				 $navItems.removeClass('is-active');
				 $(this).addClass('is-active');
				 $detailItems.addClass('Hide').eq(idx).removeClass('Hide');
			 });
		 });

	// Tự động click nav đầu tiên
	$navItems.first().trigger('click');

	// Xử lý submit form: hiển thị popup thành công (Fancybox nếu có, ngược lại alert)
	var $form = $header.find('form.form');
	$form.on('submit', function (e) {
		e.preventDefault();

		// Thực hiện gửi AJAX ở đây nếu cần (placeholder)

		// Hiển thị popup thành công: hỗ trợ Fancybox v3 (jQuery) và v4 (global), ngược lại alert
		if (window.jQuery && window.jQuery.fancybox && window.jQuery.fancybox.open) {
			window.jQuery.fancybox.open({ src: '#success-modal', type: 'inline' });
		} else if (typeof window.Fancybox !== 'undefined' && typeof window.Fancybox.show === 'function') {
			window.Fancybox.show([{ src: '#success-modal', type: 'inline' }]);
		} else if (typeof window.Fancybox !== 'undefined' && typeof window.Fancybox.open === 'function') {
			window.Fancybox.open({ src: '#success-modal', type: 'inline' });
		} else {
			alert('Gửi thông tin thành công');
		}

		// Reset form
		this.reset();
	});
});